import { DEFAULT_OFFSET_IN_PX } from './constants';
import { hightLightElement } from './utils/hightLightElement';
import { isAncestorScrollable } from './utils/isAncestorScrollable';

export const scrollToElement = ({
  elementRef,
  offset = DEFAULT_OFFSET_IN_PX,
}: {
  elementRef: React.RefObject<HTMLElement>;
  offset?: number;
}) => {
  if (!elementRef.current) return null;

  // is inside a any scrollable div container?
  if (isAncestorScrollable(elementRef.current)) {
    elementRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    hightLightElement(elementRef.current);
    return;
  }

  const scrollPosition = window.scrollY;
  const elementFromTop = elementRef.current.getBoundingClientRect().top;

  const elementPosition = scrollPosition + elementFromTop;
  const offsetPosition = elementPosition - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
  hightLightElement(elementRef.current);
};
